var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8L0.231582 1.41966C-0.0941127 1.07776 -0.0738032 0.543222 0.276946 0.225741C0.627695 -0.0917388 1.17606 -0.0719424 1.50176 0.269961L6.5 5.51692L11.4982 0.269962C11.8239 -0.0719415 12.3723 -0.0917378 12.7231 0.225742C13.0738 0.543223 13.0941 1.07776 12.7684 1.41966L6.5 8Z",
    fill: "#28AF06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.9d150efb0e2b28143f25b6f700b65fc0.svg";
export { ForwardRef as ReactComponent };